var map = {
	"./1.jpg": 46858,
	"./2.jpg": 22581,
	"./3.jpg": 18264,
	"./4.jpg": 65003,
	"./5.jpg": 86958,
	"./6.jpg": 67225,
	"./7.jpg": 96700,
	"./8.jpg": 24447,
	"./9.jpg": 32738
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74407;